// Presentation only: never round or truncate a calculated paint quantity here.
export function formatVolumeLabel(value, unit) {
    const text = String(value === null || value === undefined ? '' : value)
        .replace(/\s+/g, ' ')
        .trim()

    if (!text) return ''
    if (unit) return `${text}\u00a0${unit}`

    // Keep the quantity and its unit together, including labels read from the DOM.
    return text.replace(/\s*(gal|ml|l)$/i, '\u00a0$1')
}

export function getVolumeBadge(label, defaultSize, defaultFontSize) {
    const text = formatVolumeLabel(label)
    // Conservative Arial/Helvetica bold character widths, expressed in em.
    // A longer value gets a smaller font, not fewer decimal places. Extremely
    // long values grow the badge rather than becoming unreadably small.
    let textWidth = 0
    for (let i = 0; i < text.length; i++) {
        const character = text.charAt(i)
        if (/\d/.test(character)) textWidth += 0.62
        else if (/[.,\s]/.test(character)) textWidth += 0.32
        else textWidth += 0.75
    }

    const inset = 24
    const minimumFontSize = 12
    const size = Math.max(defaultSize, Math.ceil(textWidth * minimumFontSize + inset))
    const fontSize = Math.min(
        defaultFontSize,
        Math.max(minimumFontSize, Math.floor((size - inset) / Math.max(textWidth, 1)))
    )

    return { size, fontSize }
}
